import React from "react"
import * as React_ from "elm-ts/lib/React"
import * as M from "./Model"
import { InputField, PageLayout, BrandSpinner } from "../components"
import { flow, pipe } from "fp-ts/lib/function"
import * as E from "fp-ts/lib/Either"
import * as O from "fp-ts/lib/Option"

export function view<msg>(
  config: M.Config<msg>
): (model: M.Model) => React_.Html<msg> {
  return model => dispatch =>
    (
      <PageLayout header={<></>}>
        <div className=" grid place-items-center  h-full ">
          <div className=" w-[90vw] max-w-[400px] mb-[100px] lg:mb-[160px]">
            {pipe(
              model.logged,
              E.match(
                status => {
                  switch (status) {
                    case "Login Unverified": {
                      return (
                        <div>
                          <BrandSpinner description="Attempting to login" />
                        </div>
                      )
                    }
                    case "Login":
                    case "Login Link Failed":
                    case "Login Failed":
                    case "Error": {
                      return (
                        <>
                          {viewLogin({
                            contents: model.loginDetails,
                            submitMsg: M.Msg.loginReqMsg,
                            emailChangedMsg: flow(M.Msg.emailChanged),
                          })(flow(config.wrapperMsg, dispatch))}
                        </>
                      )
                    }
                    case "Login Failed Credentials": {
                      return (
                        <>
                          {viewLogin({
                            contents: model.loginDetails,
                            submitMsg: M.Msg.verifyLoginEmailReq,
                            emailChangedMsg: flow(M.Msg.emailChanged),
                          })(flow(config.wrapperMsg, dispatch))}
                        </>
                      )
                    }

                    case "Login Link Requested": {
                      return pipe(
                        model.loginDetails.email,
                        O.match(
                          () => <></>,
                          email => (
                            <div className="sm:mb-24">
                              <h1 className=" text-center mb-8">
                                Success!
                                <br /> Please check your email
                              </h1>
                              <p className=" text-center">
                                We sent you an email to {email}. <br />
                                It has a login link that'll sign you in.
                              </p>
                            </div>
                          )
                        )
                      )
                    }

                    default: {
                      return <></>
                    }
                  }
                },
                _ => <></>
              )
            )}
          </div>
        </div>
      </PageLayout>
    )
}

function viewLogin({
  contents,
  emailChangedMsg,
  submitMsg,
}: {
  contents: M.LoginModel
  emailChangedMsg: (email: O.Option<string>) => M.Msg
  submitMsg: () => M.Msg
}): React_.Html<M.Msg> {
  return dispatch => {
    return (
      <div className="sm:mb-24 " data-cy="login">
        <h1 className="text-center mb-8">{contents.title}</h1>
        <p className="text-center mb-14 text-[#524B6B]">
          {contents.description}
        </p>
        <form
          onSubmit={ev => {
            ev.preventDefault()
            dispatch(submitMsg())
          }}
        >
          <InputField
            value={O.getOrElse(() => "")(contents.email)}
            label="Email"
            type="email"
            name="email"
            placeholder="Email..."
            error={contents.error}
            onChangeMsg={e =>
              dispatch(emailChangedMsg(O.fromNullable(e.target.value)))
            }
            className=" bg-white border-white "
            dataCy="login-email-field"
          />
          <button
            className="button mt-4 secondary w-full"
            data-cy="login-submit-btn"
          >
            {contents.callToAction}
          </button>
        </form>
      </div>
    )
  }
}
